import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgImpact1 from '../../../../assets/img/Langding/BgImpact1.png'
import BgImpact2 from '../../../../assets/img/Langding/BgImpact2.png'
import BgImpact3 from '../../../../assets/img/Langding/BgImpact3.png'
import BgImpact4 from '../../../../assets/img/Langding/BgImpact4.png'

export const Container = styled(Box)`
  width: 100%;
  padding: 5vw 4vw;
  h1 {
    font-weight: 700;
    font-size: 50px;
    line-height: 110%;
    color: #144456;
    font-family: "PoppinsBold";
    margin-bottom: 60px;
  }
  @media only screen and (min-width: 1920px){
    padding: 100px 80px;
  }
`;
export const BoxCotent1 = styled(Box)<{reverse?:boolean}>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  flex-direction: ${({reverse})=> reverse ? 'row-reverse' :'row'};
  div {
    background: #def3ee;
    border-radius: 20px;
    padding: 52px 48px;
    align-self: stretch;
    background-size: 23%;
    background-position: ${({reverse})=> reverse ? 'right bottom' : '95% bottom' };
    :first-child {
      width: 40%;
      background-image: url('${({reverse})=> reverse ? BgImpact4 : BgImpact1 }');
      background-repeat: no-repeat;
      p{
        max-width: 450px;
      }
    }
    :last-child{
        flex:1;
        background-image: url('${({reverse})=> reverse ? BgImpact3 : BgImpact2 }');
        background-repeat: no-repeat;
        p{
            max-width: 486px;
        }
    }
    h6 {
      font-weight: 600;
      font-size: 0.9375vw;
      line-height: 110%;
      color: #00e09a;
      font-family: "PoppinsSemiBold";
      margin-bottom: 18px;
    }
    h5 {
      display: flex;
      align-items: flex-end;
      font-weight: 700;
      font-size: 3.75vw;
      line-height: 110%;
      color: #009768;
      font-family: "PoppinsBold";
      span {
        font-weight: 600;
        font-size: 0.9375vw;
        line-height: 110%;
        color: #70a896;
        font-family: "PoppinsSemiBold";
        margin-left: 14px;
      }
    }
    p {
      font-weight: 500;
      font-size: 1.25vw;
      line-height: 110%;
      color: #8094AE;
      font-family: 'PoppinsSemiBold';
      width: 100%;
      margin-top: 24px;
    }
  }
  @media only screen and (max-width: 1024px){
    div{
      h6 {
        font-size: 18px;
      }
      h5 {
        font-size: 72px;
        span {
          font-size: 18px;
        }
      }
      p {
        font-size: 24px;
      }
    }
  }
  @media only screen and (max-width: 1024px){
    flex-direction: column;
    div{
      padding: 5vw 4.68vw;
      h6 {
        font-size: 2.8vw;
      }
      h5 {
        font-size: 9.34vw;
        span {
          font-size: 2.8vw;
        }
      }
      p {
        font-size: 2.8vw;
      }
      :first-child {
        width: 100%;
      }
      :last-child {
        width: 100%;
      }
    }
  }
  @media only screen and (max-width: 430px){
    div{
      h6 {
        font-size: 12px;
      }
      h5 {
        font-size: 40px;
        span {
          font-size: 12px;
        }
      }
      p {
        font-size: 12px;
      }
    }
  }
`;
